import Chip from '@mui/material/Chip';
import TableCell from '@mui/material/TableCell';

// ----------------------------------------------------------------------

const EXIT_REASON_COLORS: Record<string, 'error' | 'warning' | 'info' | 'default'> = {
  LOW_CONFIDENCE: 'warning',
  ESCALATED: 'error',
  MAX_STEPS: 'info',
  ERROR: 'error',
};

type Props = {
  row: any;
  headerIndex: number;
  fieldKey: string;
};

export function RowCellKnowledgeGapDetails({ row, headerIndex, fieldKey }: Props) {
  if (fieldKey === 'exitReason') {
    return (
      <TableCell key={fieldKey || headerIndex}>
        <Chip
          label={row.exitReason.replace('_', ' ')}
          size="small"
          color={EXIT_REASON_COLORS[row.exitReason] ?? 'default'}
        />
      </TableCell>
    );
  }

  if (fieldKey === 'clusterCount') {
    return (
      <TableCell key={fieldKey || headerIndex}>
        <Chip
          label={`×${row.clusterCount}`}
          size="small"
          color={
            row.clusterCount >= 5
              ? 'error'
              : row.clusterCount >= 3
                ? 'warning'
                : 'default'
          }
          variant="outlined"
        />
      </TableCell>
    );
  }

  return <TableCell key={fieldKey || headerIndex} />;
}
